/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { Button } from 'ui/atoms/Button/Button';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

export const EnrichmentFinalCtaSection = () => {
  const { secondaryNavigation } = useContext(ContentContext);

  return (
    <CtaSection
      theme="dark"
      spotlight
      title="See what's missing from your data. In one file."
      description="Send us a sample of your records. We’ll return them enriched with primary registry data — match rates, sources and all."
      keywords={['600M+ records', '400+ registries', '200+ countries']}
      actions={
        <>
          {secondaryNavigation?.free_trial?.slug && (
            <Button type="white" size="xl" route={secondaryNavigation.free_trial.slug}>
              Run a free sample enrichment
            </Button>
          )}

          {secondaryNavigation?.book_demo?.slug && (
            <Button type="white-outline" size="xl" route={secondaryNavigation.book_demo.slug}>
              Talk to sales
            </Button>
          )}
        </>
      }
    />
  );
};
